export const submit_phase_index = -1;